import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import useEscapeKey from "../../hooks/useEscapeKey";
import "./Drawer.css";
import Button from "../Button/Button";

const Drawer = ({ open, onClose, title, children }) => {
  const panelRef = useRef(null);

  useEffect(() => {
    if (!open) return;

    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = "hidden";
    document.body.style.paddingRight = `${scrollbarWidth}px`;

    const focusable = panelRef.current?.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (focusable?.length) focusable[0].focus();

    return () => {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    };
  }, [open]);

  useEscapeKey(onClose, open);

  return createPortal(
    <div className={`drawer-overlay${open ? " drawer-overlay-visible" : ""}`}>
      <div className="drawer-backdrop" onClick={onClose} />
      <div
        ref={panelRef}
        className={`drawer-panel${open ? " drawer-open" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="drawer-title"
      >
        <div className="drawer-header">
          <h2 id="drawer-title" className="drawer-title">{title}</h2>
          <Button variant="icon" className="drawer-close" onClick={onClose} aria-label="Close drawer">
            <span className="material-symbols-outlined">close</span>
          </Button>
        </div>
        <div className="drawer-body">{children}</div>
      </div>
    </div>,
    document.body
  );
};

export default Drawer;
